export default __webpack_public_path__ + "img/e741d85ccdacd4c8a23f9d3523895c24.svg";